const i = (o, l, n, a, T) => {
  var t, c;
  const f = (n == null ? void 0 : n.title) || ((t = l == null ? void 0 : l[a - 1]) == null ? void 0 : t.title) || ((c = l == null ? void 0 : l[a - 2]) == null ? void 0 : c.title);
  return [o, f, T.title].filter(Boolean).join(" > ");
};
export {
  i as getTrackingNavigationText
};
